import React from "react";
import style from "./style.module.scss";
import Row from "./Row";
import SkeletonRow from "../../../../../components/skeleton-loader/table/row";
import { formatCurrency } from "../../../../../../components/helper/helper";

const CardBrandAssessments = ({ data = [], loading }) => {
  const tableData = Array.isArray(data)
    ? data.filter((row) => Number(row?.num || 0) > 0)
    : [];

  const totals = tableData.reduce(
    (acc, row) => ({
      income: acc.income + (row.income || 0),
      expense: acc.expense + (row.expense || 0),
    }),
    { income: 0, expense: 0 },
  );

  return (
    <div className={style.table_container}>
      <table className={style.table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}>Card</th>
            <th className={style.header_cell}>Desc</th>
            <th className={style.header_cell}>Num</th>
            <th className={style.header_cell}>Amount</th>
            <th className={style.header_cell}>Income</th>
            <th className={style.header_cell}>Expense</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <SkeletonRow key={`cba-skeleton-${index}`} columnLength={6} />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="6" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            <>
              {tableData.map((row, index) => (
                <Row data={row} key={index} />
              ))}
              <tr className={style.footer_row}>
                <td className={style.footer_cell}>Total</td>
                <td className={style.footer_cell} />
                <td className={style.footer_cell} />
                <td className={style.footer_cell} />
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.income)}
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.expense)}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CardBrandAssessments;
